module.exports = __webpack_public_path__ + "assets/media/RIGHT_ARROW_WITH_TEXT.ff494ec7.svg";